import { MARQUEE } from "@/data/content";

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
    {MARQUEE.map((t) => (
      <span key={t} className="flex items-center">
        <span className="px-8 font-heading text-3xl sm:text-5xl font-black italic tracking-tight text-cream whitespace-nowrap">{t}</span>
        <svg viewBox="0 0 24 24" className="h-6 w-6 sm:h-8 sm:w-8 fill-gold" aria-hidden="true"><path d="M12 21s-7.5-4.6-9.6-9.2C.9 8.4 3 5 6.4 5c2 0 3.5 1.1 4.3 2.6h2.6C14.1 6.1 15.6 5 17.6 5 21 5 23.1 8.4 21.6 11.8 19.5 16.4 12 21 12 21z" /></svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="editorial-marquee" aria-label="KeepThis! in a few words" className="relative overflow-hidden bg-navy py-7 sm:py-9 -rotate-[1.2deg] scale-[1.03]">
    <div className="flex w-max animate-[marquee_60s_linear_infinite] hover:[animation-play-state:paused]">
      <Row />
      <Row hidden />
    </div>
  </section>
);
